import { apiFetch } from "@ecom/ui/utils/api"
import { SendToApiResponse } from "../../interfaces/sendToApiResponse"
import { POSTBACK_BASE_URL } from "./config"

export function sendPostback(applicationResponse: SendToApiResponse, productName?: string) {
  const { requestId, status, partnerExternalId } = applicationResponse

  const payload = {
    url: window.location.href,
    productName,
    requestId,
    status,
    partnerExternalId,
    cookie: document.cookie,
  }

  apiFetch(`${POSTBACK_BASE_URL}/exec`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    keepalive: true, // полезно, если вызываешь при закрытии страницы
    body: JSON.stringify(payload),
  }).catch((err: Error) => {
    console.warn("postback failed:", err)
  })
}
